import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllForeignerLevyTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.ForeignerLevyTypeAPI}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getForeignerLevyTypeById = async ({ companyCode,code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.ForeignerLevyTypeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertForeignerLevyType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.ForeignerLevyTypeAPI, input);
  return data;
};

const updateForeignerLevyType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.ForeignerLevyTypeAPI, input);
  return data;
};

const deleteForeignerLevyType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.ForeignerLevyTypeAPI}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetForeignerLevyTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.ForeignerLevyTypeAPI],
    queryFn: () => getAllForeignerLevyTypes(input),
    // refetchOnWindowFocus: false,
  });
};

export const useGetForeignerLevyTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.ForeignerLevyTypeAPI],
    queryFn: () => getForeignerLevyTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertForeignerLevyTypeMutation = () => {
  return useMutation({
    mutationFn: insertForeignerLevyType,
  });
};

export const useUpdateForeignerLevyTypeMutation = () => {
  return useMutation({
    mutationFn: updateForeignerLevyType,
  });
};

export const useDeleteForeignerLevyTypeMutation = () => {
  return useMutation({
    mutationFn: deleteForeignerLevyType,
  });
};
